import React, { useState, useEffect } from "react";
import axios from "./../../api/axiosInstance";
import CustomerP from "../../../Assets/customerP.png";
import Customer1 from "../../../Assets/c1.png";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import HydrationSafeSlider from "../../utils/HydrationSafeSlider";
import "./Customers.css";
import axiosInstance from "./../../api/axiosInstance";
import { getPreloadedData, PreloadedScript } from "../../utils/preloadedData";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Round previous/next buttons for the testimonial slider. react-slick passes onClick (and a className we ignore,
// because the old global .slick-next rule hides slick's own arrows).
function SlideArrow({ direction, onClick }) {
  const isPrev = direction === "prev";
  return (
    <button
      type="button"
      className={`slider_arrow_btn testimonial_arrow testimonial_arrow_${direction}`}
      onClick={onClick}
      aria-label={isPrev ? "Previous testimonials" : "Next testimonials"}
    >
      {isPrev ? <IoChevronBack aria-hidden="true" /> : <IoChevronForward aria-hidden="true" />}
    </button>
  );
}

function Customers() {
  const [testimonials, setTestimonials] = useState(() => getPreloadedData("__PRELOADED_TESTIMONIALS__") || []);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    axiosInstance
      .get("api/testimonials")
      .then((response) => {
        console.log("Fetched testimonials:", response.data);
        const sortedTestimonials = (response.data || []).sort(
          (a, b) => b.id - a.id
        );
        setTestimonials(sortedTestimonials);
      })
      .catch((error) => {
        console.error("There was an error fetching the testimonials!", error);
      });
  }, []);

  // react-slick's infinite loop breaks (skipped/duplicated slides, incorrect
  // dot count) whenever slidesToShow is larger than the number of slides
  // actually rendered, so every breakpoint below is capped to the real count.
  const slideCount = testimonials.length;
  const cap = (n) => Math.min(n, Math.max(slideCount, 1));

  const settings = {
    // Arrows only where there is something to slide to: at each breakpoint, only if there are more testimonials than fit
    arrows: slideCount > 3,
    prevArrow: <SlideArrow direction="prev" />,
    nextArrow: <SlideArrow direction="next" />,
    dots: true,
    infinite: slideCount > 1,
    slidesToShow: cap(3),
    slidesToScroll: cap(1),
    cssEase: "linear",
    speed: 2000,
    autoplay: slideCount > 1,
    autoplaySpeed: 1500,
    lazyLoad: "ondemand",
    customPaging: function (i) {
      return (
        <div
          className={`blue_line_slick ${
            i === currentSlide ? "blue_line_slick_active" : ""
          }`}
        />
      );
    },
    afterChange: function (current) {
      setCurrentSlide(current);
    },
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: cap(2), slidesToScroll: cap(1), arrows: slideCount > 2 } },
      { breakpoint: 780, settings: { slidesToShow: cap(2), slidesToScroll: cap(1), arrows: slideCount > 2 } },
      { breakpoint: 600, settings: { slidesToShow: cap(1), slidesToScroll: cap(1), arrows: slideCount > 1 } },
    ],
  };

  const handleImageError = (e, authorName) => {
    console.error(`Failed to load image for ${authorName}: ${e.target.src}`);
    e.target.src = Customer1;
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return Customer1;
    return `${BASE_URL}/${imageUrl}`;
  };

  return (
    <div className="main_div_customer">
      <PreloadedScript id="__PRELOADED_TESTIMONIALS__" data={testimonials} />
      <div className="row p-0 m-0">
        <div className="col-12">
          <p className="testimonial_heading">Testimonial</p>
          <h2 className="saying_customer_para">What Our Customers Are Saying</h2>
          <div className="hr_black_customers"></div>
          <HydrationSafeSlider settings={settings}>
            {testimonials.length > 0 ? (
              testimonials.map((testimonial, index) => (
                <div key={index} className="col">
                  <div className="main_div_card_customer">
                    <div className="d-flex">
                      <img
                        src={CustomerP}
                        alt=""
                        className="comma_customer_card"
                        width="60"
                        height="60"
                        loading="lazy"
                      />
                    </div>
                    <blockquote className="para_comment_card">
                      {testimonial.text}
                    </blockquote>
                    <div className="customer_author">
                      <img
                        src={getImageUrl(testimonial.image)}
                        className="profile_pic_customer_card"
                        alt={`Customer ${testimonial.author_name}`}
                        width="56"
                        height="56"
                        onError={(e) => handleImageError(e, testimonial.author_name)}
                        loading="lazy"
                      />
                      <div className="customer_info">
                        <p className="customer_name">{testimonial.author_name}</p>
                        <p className="customer_role">{testimonial.author_role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : null}
          </HydrationSafeSlider>
        </div>
      </div>
    </div>
  );
}

export default Customers;